<template>
  <main>
    <div class="c-section c-section--small-top">
      <div class="c-toolbar u-mb+ u-mb++@desktop">
        <router-link class="u-st1 u-700" :to="{ name: 'news' }">
          <img class="u-mr--" src="@/assets/arrow-left-blue.svg" alt="Left arrow" height="14"> Back to all news
        </router-link>
      </div>
      <div class="o-wrapper">
        <div class="u-3/4@desktop">
          <div class="u-st1 u-hl-grey-1 u-mb">
            <div v-if="entry.author">By {{ entry.author }}</div>
            <div class="u-uppercase" v-if="entry.date.date">Published {{ entry.date.date }}</div>
          </div>
          <h1 class="c-section__heading u-mb-" v-if="entry.title">{{ entry.title }}</h1>
          <p class="u-h4 u-hl-blue-royal" v-if="entry.subheading">{{ entry.subheading }}</p>
        </div>
        <div v-for="content in entry.content" :key="content.id">
          <div class="c-rte u-mb+" v-if="content.type == 'text'" v-html="content.text"></div>
          <div class="c-gallery u-mb+" v-if="content.type == 'imagesHorizontal'">
            <div class="c-gallery" v-if="content.images.length > 1">
              <div class="js-gallery">
                <div class="c-rte-img-caption" v-for="image in content.images" :key="image.id">
                  <img :src="image.url" alt="">
                  <div class="c-rte-img-caption__content u-st2" v-if="image.caption || image.credit">
                    <div class="u-3/4@desktop">
                      <span v-if="image.caption">{{ image.caption }}</span>
                      <span class="u-uppercase" v-if="image.credit">&copy; {{ image.credit }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="c-gallery__btn c-gallery__btn--prev js-gallery__prev">
                <img src="@/assets/caret-left-blue.svg" height="32" alt="Left caret">
              </button>
              <button class="c-gallery__btn c-gallery__btn--next js-gallery__next">
                <img src="@/assets/caret-right-blue.svg" height="32" alt="Right caret">
              </button>
            </div>
            <div class="c-rte-img-caption u-mb+" v-else-if="content.images.length === 1">
              <img :src="content.images[0].url">
              <div class="c-rte-img-caption__content u-st2" v-if="content.images[0].caption || content.images[0].credit">
                <div class="u-3/4@desktop">
                  <span v-if="content.images[0].caption">{{ content.images[0].caption }}</span>
                  <span class="u-uppercase" v-if="content.images[0].credit">&copy; {{ content.images[0].credit }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="c-rte-img-group u-mb+" v-if="content.type == 'imagesVertical'">
            <div class="c-rte-img-group__item" v-for="image in content.images" :key="image.id">
              <div class="c-rte-img-caption">
                <img :src="image.url" alt="">
                <div class="c-rte-img-caption__content u-st2" v-if="image.caption || image.credit">
                  <span v-if="image.caption">{{ image.caption }}</span>
                  <span class="u-uppercase" v-if="image.credit">&copy; {{ image.credit }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-post-footer">
          <ul class="o-list-inline u-mb- u-mb0@desktop">
            <li class="o-list-inline__item u-mr--">
              <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + entry.url" target="_blank">
                <img src="@/assets/facebook-grey.svg" alt="Twitter" height="32">
              </a>
            </li>
            <li class="o-list-inline__item u-mr--">
              <a :href="'https://twitter.com/home?status=' + entry.url" target="_blank">
                <img src="@/assets/twitter-grey.svg" alt="Facebook" height="32">
              </a>
            </li>
            <li class="o-list-inline__item">
              <span class="u-st2 u-uppercase u-hl-grey-1 u-700 u-lts1">Share</span>
            </li>
          </ul>
          <router-link class="u-st2 u-uppercase u-hl-grey-1 u-700 u-lts1" :to="{ name: 'news' }">Back to all news</router-link>
        </div>
      </div>
    </div>
    <banner />
  </main>
</template>

<script>
import axios from 'axios'
import Siema from 'siema'
import moment from 'moment'
import Banner from '@/components/Banner.vue'

export default {
  name: 'Post',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Banner: Banner
  },
  data () {
    return {
      title: '',
      entry: null
    }
  },
  mounted () {
    this.getEntry()
  },
  methods: {
    getEntry () {
      axios
        .get('/api/posts/' + this.$route.params.slug + '.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
          this.entry.date.date = moment(this.entry.date.date).format('D MMMM YYYY')
          this.$nextTick(() => this.createGallery())
        })
    },
    createGallery () {
      const mySiema = new Siema({
        selector: '.js-gallery',
        loop: true,
        draggable: false,
        duration: 800
      })
      document.querySelector('.js-gallery__prev').addEventListener('click', () => mySiema.prev())
      document.querySelector('.js-gallery__next').addEventListener('click', () => mySiema.next())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Post.vue